var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
import to from 'await-to-js';
import logger from 'app/helpers/logger';
import constants from 'app/constants/global-constants';
import ApiClient from './apiClient';
var getUseCases = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var urlParams, api, _a, err, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                urlParams = params.additionalUc
                    ? "?additionalUc=".concat(params.additionalUc)
                    : '';
                api = new ApiClient();
                return [4 /*yield*/, api.get("/SandboxGetUsecases".concat(urlParams))];
            case 1:
                _a = _b.sent(), err = _a[0], response = _a[1];
                return [2 /*return*/, [err, response ? response.data : null]];
        }
    });
}); };
var createInstance = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var usecase, _a, isDraft, _b, body, api, requestBody, _c, err, response;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                logger.log('createInstance', params);
                usecase = params.usecase, _a = params.isDraft, isDraft = _a === void 0 ? false : _a, _b = params.body, body = _b === void 0 ? {} : _b;
                api = new ApiClient();
                requestBody = __assign({ usecase: usecase, draft_only: isDraft }, body);
                logger.log(requestBody);
                return [4 /*yield*/, api.post('/SandboxCreateInstance', requestBody)];
            case 1:
                _c = _d.sent(), err = _c[0], response = _c[1];
                return [2 /*return*/, [err, response ? response.data : null]];
        }
    });
}); };
var getUserRunningInstance = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var timezone, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                timezone = '';
                try {
                    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                }
                catch (err) {
                    logger.log(err);
                    timezone = 'GMT';
                }
                return [4 /*yield*/, to(Axios.get("".concat(constants.API_BASE_URL_v2, "/SandboxGetRunningInstancesForUser?timezone=").concat(timezone), {
                        headers: {
                            Authorization: accessToken,
                            Accept: 'application/json, text/javascript, */*; q=0.01',
                            'Cache-Control': 'max-age=0',
                        },
                    }))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data.data || null]];
        }
    });
}); };
var terminateSandboxInstance = function (accessToken, sandboxHashKey) { return __awaiter(void 0, void 0, void 0, function () {
    var config;
    return __generator(this, function (_a) {
        config = {
            headers: {
                Authorization: accessToken,
                Accept: 'application/json, text/javascript, */*; q=0.01',
                'Content-Type': 'application/json',
            },
        };
        return [2 /*return*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxStopInstance"), { sandboxHashKey: sandboxHashKey }, config))];
    });
}); };
var getBackupsByHash = function (accessToken, sandboxHashKey) { return __awaiter(void 0, void 0, void 0, function () {
    var config, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: accessToken,
                        Accept: 'application/json, text/javascript, */*; q=0.01',
                        'Cache-Control': 'max-age=0',
                    }
                };
                return [4 /*yield*/, to(Axios.get("".concat(constants.API_BASE_URL_v2, "/SandboxBackup/").concat(sandboxHashKey), config))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data]];
        }
    });
}); };
var getSandboxByHash = function (accessToken, sandboxHashKey) { return __awaiter(void 0, void 0, void 0, function () {
    var config, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: accessToken,
                        Accept: 'application/json, text/javascript, */*; q=0.01',
                        'Cache-Control': 'max-age=0',
                    },
                    params: {
                        sandboxHashKey: sandboxHashKey,
                        verifyConnect: true,
                    },
                };
                return [4 /*yield*/, to(Axios.get("".concat(constants.API_BASE_URL_v2, "/SandboxGetInstanceByHashKey"), config))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data]];
        }
    });
}); };
var requestSandboxBackup = function (accessToken, sandboxHashKey) { return __awaiter(void 0, void 0, void 0, function () {
    var config, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: accessToken,
                        Accept: 'application/json, text/javascript, */*; q=0.01',
                        'Cache-Control': 'max-age=0'
                    }
                };
                return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxBackup/request/").concat(sandboxHashKey), {}, config))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data]];
        }
    });
}); };
var requestSandboxBackupLink = function (accessToken, sandboxHashKey, key) { return __awaiter(void 0, void 0, void 0, function () {
    var config, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: accessToken,
                        Accept: 'application/json, text/javascript, */*; q=0.01',
                        'Cache-Control': 'max-age=0'
                    }
                };
                return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxBackup/").concat(sandboxHashKey), { "key": key }, config))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data]];
        }
    });
}); };
var checkSandboxBackupResult = function (accessToken, resultId) { return __awaiter(void 0, void 0, void 0, function () {
    var config, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: accessToken
                    }
                };
                return [4 /*yield*/, to(Axios.get("".concat(constants.API_BASE_URL_v2, "/SandboxBackup/result/").concat(resultId), config))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data]];
        }
    });
}); };
var extendSandboxByHash = function (accessToken, data) { return __awaiter(void 0, void 0, void 0, function () {
    var config;
    return __generator(this, function (_a) {
        config = {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json',
            },
        };
        return [2 /*return*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxExtend"), data, config))];
    });
}); };
var inviteToSandbox = function (accessToken, data) { return __awaiter(void 0, void 0, void 0, function () {
    var config;
    return __generator(this, function (_a) {
        config = {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json',
            },
        };
        return [2 /*return*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxShare"), data, config))];
    });
}); };
var acceptInvitation = function (accessToken, invitationCode) { return __awaiter(void 0, void 0, void 0, function () {
    var config;
    return __generator(this, function (_a) {
        config = {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json',
            },
        };
        return [2 /*return*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxShareAccept"), { auth_token: invitationCode }, config))];
    });
}); };
export default {
    getUserRunningInstance: getUserRunningInstance,
    getBackupsByHash: getBackupsByHash,
    getSandboxByHash: getSandboxByHash,
    requestSandboxBackup: requestSandboxBackup,
    requestSandboxBackupLink: requestSandboxBackupLink,
    checkSandboxBackupResult: checkSandboxBackupResult,
    createInstance: createInstance,
    terminateSandboxInstance: terminateSandboxInstance,
    extendSandboxByHash: extendSandboxByHash,
    getUseCases: getUseCases,
    inviteToSandbox: inviteToSandbox,
    acceptInvitation: acceptInvitation,
};
